// Character sprites, keyed by world → agent id.
// An agent with no entry falls back to the dot-bot courier and no resident.
// Leads/Clients reuse the Internal character set (closest match by role) until
// they get their own sheets: slice per-agent transparent PNGs into
// assets/sprites/<world>/ and swap the entries in that world's block.

import contractsAndRecords from "../assets/sprites/internal/contracts-and-records.png";
import billingAndCollections from "../assets/sprites/internal/billing-and-collections.png";
import bookkeepingAgent from "../assets/sprites/internal/bookkeeping-agent.png";
import financeReporter from "../assets/sprites/internal/finance-reporter.png";
import internalOpsManager from "../assets/sprites/internal/internal-ops-manager.png";
import taskOrchestrator from "../assets/sprites/internal/task-orchestrator.png";
import deliverablesTracker from "../assets/sprites/internal/deliverables-tracker.png";
import schedulerAgent from "../assets/sprites/internal/scheduler-agent.png";
import teamAndToolsOps from "../assets/sprites/internal/team-and-tools-ops.png";
import knowledgeBaseAgent from "../assets/sprites/internal/knowledge-base-agent.png";
import portalChief from "../assets/sprites/internal/portal-chief.png";
import eventOpsAgent from "../assets/sprites/internal/event-ops-agent.png";

const INTERNAL = {
  "contracts-and-records": contractsAndRecords,
  "billing-and-collections": billingAndCollections,
  "bookkeeping-agent": bookkeepingAgent,
  "finance-reporter": financeReporter,
  "internal-ops-manager": internalOpsManager,
  "task-orchestrator": taskOrchestrator,
  "deliverables-tracker": deliverablesTracker,
  "scheduler-agent": schedulerAgent,
  "team-and-tools-ops": teamAndToolsOps,
  "knowledge-base-agent": knowledgeBaseAgent,
  "portal-chief": portalChief,
  "event-ops-agent": eventOpsAgent,
};

const I = INTERNAL;

// Neighbouring houses get different characters so a district doesn't read as clones.
export const SPRITES = {
  internal: INTERNAL,
  leads: {
    "prospect-miner": I["knowledge-base-agent"],
    "social-listener": I["event-ops-agent"],
    "outbound-sequencer": I["scheduler-agent"],
    "cold-caller": I["portal-chief"],
    "social-prospector": I["team-and-tools-ops"],
    "referral-agent": I["contracts-and-records"],
    "reactivation-agent": I["task-orchestrator"],
    "newsletter-agent": I["finance-reporter"],
    "content-repurposer": I["knowledge-base-agent"],
    "engagement-agent": I["event-ops-agent"],
    "campaign-agent": I["deliverables-tracker"],
    "speed-to-lead": I["task-orchestrator"],
    "qualifier": I["bookkeeping-agent"],
    "booking-agent": I["scheduler-agent"],
    "call-intelligence": I["portal-chief"],
    "analysis-builder": I["finance-reporter"],
    "program-builder": I["contracts-and-records"],
    "stage-nurture": I["billing-and-collections"],
    "lead-manager": I["internal-ops-manager"],
  },
  clients: {
    "onboarding-agent": I["portal-chief"],
    "intake-agent": I["contracts-and-records"],
    "systems-setup-agent": I["team-and-tools-ops"],
    "assessment-and-goals": I["finance-reporter"],
    "roadmap-and-priorities": I["task-orchestrator"],
    "sales-coach": I["billing-and-collections"],
    "operations-coach": I["deliverables-tracker"],
    "technology-coach": I["team-and-tools-ops"],
    "marketing-coach": I["event-ops-agent"],
    "finance-coach": I["bookkeeping-agent"],
    "hr-coach": I["knowledge-base-agent"],
    "session-agent": I["scheduler-agent"],
    "accountability-agent": I["task-orchestrator"],
    "scorecard-agent": I["finance-reporter"],
    "pulse-agent": I["knowledge-base-agent"],
    "renewal-agent": I["contracts-and-records"],
    "community-agent": I["event-ops-agent"],
    "client-manager": I["internal-ops-manager"],
    // the Lead Manager walks the bridge in from Leads World
    "lead-manager": I["internal-ops-manager"],
  },
};
